import { getAnalytics, logEvent } from 'firebase/analytics';
import { firebaseApp } from 'libs/analyticsconfig';
export default class FirebaseAnalytics {
  static analytics = getAnalytics(firebaseApp);

  static log(eventName) {
    logEvent(this.analytics, eventName);
  }

  static logWithValue(eventName, value) {
    logEvent(this.analytics, eventName, value);
  }
}

export const AnalyticsLogStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};
